// import React from "react";
// // import { NavLink } from "react-router-dom";
// import { UseAuth } from "../context/Auth";
// import Header from "../component/Header";
// import Carousel from "../component/Carousel";

// const Home = () => {
//   const { token } = UseAuth();
//   console.log(token);
//   return (
//     <React.Fragment>
//       <Header title='VASTHU SASTRA' breakpionts='lg' navList={[{link:'login',pageName:'LOGIN'}, {link:'register', pageName:'REGISTER'}]} />
//       <Carousel />
//     </React.Fragment>
//   );
// };

// export default Home;

import React, { useState } from "react";
// import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Carousel from "../component/Carousel";
import HomeConsultant from "../component/HomeConsultant";
import HomeFooterInfo from "../component/HomeFooterInfo";
import HomeTestimonials from "../component/HomeTestimonials";
import { UseAuth } from "../context/Auth";
import HomePageOffers from "../component/HomePageOffers";
import HomeServices from "../component/HomeServices";
import HelmetSeo from "../component/HelmetSeo";
import HomeClickAstro from "../component/HomeClickAstro";
import BasicSpeedDial from "./BasicSpeedDial";
import OurProducts from "./OurProducts";
import ScrollButton from "./ScrollButton";

const UserHome = () => {
  const { onLogout } = UseAuth();
  const token = window.sessionStorage.getItem("token");
  const navigate = useNavigate();

  const [paytmurl, setPaytmurl] = useState("");

  let subtitle;
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  async function openModal() {
    await pay()
      .then(setIsOpen(true))
      .catch(console.log("some network issue"));
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#f00";
  }

  function closeModal() {
    setIsOpen(false);
  }

  //   useEffect(() => {
  //     const queryString = window.location.search;
  // console.log(queryString);
  // const urlParams = new URLSearchParams(queryString);
  // const bank = urlParams.get('BANKNAME')
  // console.log(bank);

  //   })
  const pay = async () => {
    await fetch(`http://localhost:8080/vasthu/submitPaymentDetail`, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        ORDER_ID: "or12897",
        TXN_AMOUNT: "100",
        CUST_ID: "cus45786",
      }),
    })
      .then(async (rawResponse) => {
        const content = await rawResponse;
        console.log(content);
        // console.log(content.url);
        setPaytmurl(content.url);
      })
      .catch((err) => console.log("fetch error -- " + err));
  };

  return (
    <React.Fragment>
      <HelmetSeo
        title="Vasthuparam - Free Online Astrology Consultation"
        name="description"
        content="Vasthuparam - Free Online Astrology Consultation"
        relCa="canonical"
        hrefCa="https://www.vasthuparam.com/"
        relAl="canonical"
        hrefAl="https://m.www.vasthuparam.com/"
      />
      <div>
        {/* <HomeMarquee /> */}
        <Carousel />
        {/* <ScrollButton /> */}
        {/* <ScrollButton /> */}
        <HomeServices />
        <HomePageOffers />
        {/* <OurServicesConsultant /> */}
        {/* <HomeServicePlans /> */}
        {/* <CustomerOneTimePricing />
      <CustomerPeriodicPricing /> */}
        <HomeConsultant />
        <OurProducts />
        <HomeTestimonials />
        {/* <HomeUserReview /> */}
        <HomeFooterInfo />
      </div>
      <div
        style={{
          position: "fixed",
          top: "65%",
          width: "100%",
          height: "100%",
        }}
      >
        <HomeClickAstro />
        <div
          style={{
            float: "right",
            padding: "7px",
            borderRadius: "7px",
            marginRight: "5px",
          }}
        >
          <div className="d-none d-lg-inline">
            <BasicSpeedDial />
          </div>
          <ScrollButton />
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserHome;
